import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const GOOD_RECEIPT_NOTE_URL = `${backendUrl}/goodReceiptNote`;

const initialState = {
  isLoading: false,
  error: null,
  goodReceiptNotes: [],
  goodReceiptNote: null,
  page: 1,
  limit: 10,
  totalPages: 0,
  totalResults: 0,
};

const slice = createSlice({
  name: "accountsGoodReceiptNote",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getGoodReceiptNotesSuccess(state, action) {
      const payload = action.payload || {};
      state.isLoading = false;
      state.goodReceiptNotes = payload.results || [];
      state.page = payload.page || 1;
      state.limit = payload.limit || 10;
      state.totalPages = payload.totalPages || 0;
      state.totalResults = payload.totalResults || 0;
    },
    getGoodReceiptNoteSuccess(state, action) {
      state.isLoading = false;
      state.goodReceiptNote = action.payload;
    },
    clearGoodReceiptNote(state) {
      state.goodReceiptNote = null;
      state.error = null;
    },
  },
});

export default slice.reducer;

export function getAccountsGoodReceiptNotes({ franchiseId, warehouseId, page = 1, limit = 10 }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(GOOD_RECEIPT_NOTE_URL, {
        params: { franchiseId, warehouseId, page, limit },
      });
      dispatch(slice.actions.getGoodReceiptNotesSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function getAccountsGoodReceiptNote(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${GOOD_RECEIPT_NOTE_URL}/${id}`);
      dispatch(slice.actions.getGoodReceiptNoteSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function createAccountsGoodReceiptNote(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(GOOD_RECEIPT_NOTE_URL, data);
      dispatch(slice.actions.getGoodReceiptNoteSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function updateAccountsGoodReceiptNote(id, data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`${GOOD_RECEIPT_NOTE_URL}/${id}`, data);
      dispatch(slice.actions.getGoodReceiptNoteSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export const { clearGoodReceiptNote } = slice.actions;
